module.exports = __webpack_public_path__ + "img/em14.eb205fc6.jpg";